import { getStoreCurrency } from '../shopify/getStoreCurrency';
import { baseConfig } from '../../config/algolia';
import { JbCart, JbCartItem } from '@jbhi-fi/apis/src/shopify/types/JbCart';

export abstract class AlgoliaTrackingCartTransformer {
  static transformCartItemForAlgoliaTracking = (item: JbCartItem & { queryId?: string }) => {
    const saveAmount = item.line_price - item.final_line_price;

    return {
      discount: Number((saveAmount / item.quantity / 100).toFixed(2)),
      price: Number((item.final_line_price / item.quantity / 100).toFixed(2)),
      quantity: item.quantity,
      sku: item.sku,
      queryId: item.queryId,
    };
  };

  static transformCartForAlgoliaTracking = (cartItems: JbCart['items']) => {
    return {
      index: baseConfig.product_families_index ?? '',
      objectIDs: cartItems.map(item => item.sku),
      objectData: cartItems.map(item => AlgoliaTrackingCartTransformer.transformCartItemForAlgoliaTracking(item)),
      value: (cartItems.reduce((acc, item) => acc + item.final_line_price, 0) / 100).toFixed(2),
      currency: getStoreCurrency(),
    };
  };
}
